module.exports = __webpack_public_path__ + "static/media/Puntu-Icon-Download.c55c8b43.png";